<template>
  <ion-page>
    <master-layout pageTitle="ویرایش اطلاعات آدرس">
      <ion-card>
        <ion-card-content>
          <Loading :is="!addressLoaded" v-if="!addressLoaded"></Loading>
          <div v-if="addressLoaded">
            <div v-if="address">
              <AjaxForm :route="'address/Edit/'+id">
                <div>
                  <label>عنوان</label>
                  <input type="text" name="title" :value="address.title" class="form-control">
                </div>
                <div>
                  <label>نام تحویل گیرنده</label>
                  <input type="text" name="fullname" :value="address.fullname" class="form-control">
                </div>
                <div>
                  <label>تلفن تماس</label>
                  <input type="text" name="phone" class="form-control" :value="address.phone">
                </div>
                <div>
                  <label>آدرس</label>
                  <textarea name="address" v-model="address.address" class="form-control"></textarea>
                </div>
                <div>
                  <label>استان</label>
                  <select autocomplete="off"
                          class="form-control"
                          @change="getCities($event)" name="state_id">
                    <option value="0" disabled selected>لطفا استان مورد نظر را انتخاب نمایید</option>
                    <option :selected="state._id === address.state._id" :key="state._id" v-for="state in states" :value="state._id">{{ state.title }}</option>
                  </select>
                </div>
                <div class="mb-2">
                  <label>شهر</label>
                  <div class="city_div">
                    <select name="city_id" data-title="استان را انتخاب کنید" class="form-control">
                      <option :key="city._id" :selected="city._id === address.city._id" v-for="city in cities" :value="city._id">{{ city.title }}</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>کدپستی</label>
                  <input type="tel" name="postal_code" class="form-control" :value="address.postal_code">
                </div>
                <div class="mt-2">
                  <input value="1" autocomplete="off" type="checkbox"
                         :checked="address.default"
                         class="custom-control-input" id="customCheck"
                         name="default">
                  <label class="custom-control-label" for="customCheck">&nbsp;آدرس پیش فرض باشد</label>
                </div>
                <ion-button expand="full" color="secondary" type="submit">ویرایش آدرس</ion-button>
              </AjaxForm>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
import {IonPage, IonCard, IonCardContent, IonCardHeader} from '@ionic/vue';
import AjaxForm from "@/components/AjaxForm";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    AjaxForm,
    IonPage, IonCard, IonCardContent, IonCardHeader
  },
  data()
  {
    return {
      id: null,
      addressLoaded: false,
      address: null,
      error: null,
      states: [],
      cities: [{_id: 0, title: 'ابتدا استان را انتخاب نمایید'}]
    }
  },
  async created()
  {
    this.id = this.$route.params.id;
    await this.init();
  },
  methods: {
    ...mapActions("app", {
      getStates: 'getStates',
      apiGetCities: 'getCities',
    }),
    ...mapActions("address", {
      getAddress: 'getAddress'
    }),
    async init()
    {
      this.addressLoaded = false;
      this.address = null;
      const result = await this.getAddress(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.addressLoaded = true;
          this.address = result.address;
          if (!this.states.length)
          {
            this.states = await this.getStates();
          }
          if (this.address.state._id)
          {
            const cities = await this.apiGetCities(this.address.state._id);
            if (cities && cities.ok)
            {
              this.cities = cities.cities;
            }
          }
        }
        else
        {
          this.addressLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.addressLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    async getCities(event)
    {
      const result = await this.apiGetCities(event.target.value);
      if (result)
      {
        this.cities = result.cities;
      }
    }
  },watch: {
    "$route.path": {
      handler(newUrl)
      {
        if (newUrl.toLowerCase().indexOf('address/edit') >= 0)
        {
          this.init()
        }
      },
      deep: true,
    },
  }
}

</script>

<style scoped>

</style>